import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { validateUuid } from '@/utils/validate-uuid';
import { SafetyAndHygieneResponsibleService } from '@/infra/services/safety-hygiene-responsible';

interface GetSafetyAndHygieneResponsibleParams {
	id: string;
	company_id: string;
	organization_id: string;
}

const Service = SafetyAndHygieneResponsibleService.getInstance();

export const useGetSafetyAndHygieneResponsible = (params: GetSafetyAndHygieneResponsibleParams) => {
	const isEnabled = validateUuid([params.company_id, params.organization_id, params.id]);
	return useQuery({
		queryKey: [QUERY_KEYS.GET_SAFETY_AND_HYGIENE_RESPONSIBLE, params],
		queryFn: async () => Service.show(params),
		enabled: isEnabled
	});
};
